import NextLink, { type LinkProps } from "next/link";
import React from "react";

type AppLinkProps = LinkProps &
  React.ComponentPropsWithoutRef<"a"> & {
    current?: boolean;
    active?: boolean;
  };

export const Link = React.forwardRef(function Link(
  props: AppLinkProps,
  ref: React.ForwardedRef<HTMLAnchorElement>,
) {
  const { current: _current, active: _active, ...linkProps } = props;
  return <NextLink {...linkProps} ref={ref} />;
});
